export default __webpack_public_path__ + "assets/ba5361556105756d0d885651570a397a.png";